export default "__VITE_PUBLIC_ASSET__e470dcb5__"